module.exports = __webpack_public_path__ + "img/suit (4).1c0af899.png";